<template>
  <div class="card">
    <div class="heading">
      <h2>Datos Generales</h2>
    </div>
    <div class="d-flex gap-7">
      <span>Usuario administrador de la empresa</span>
      <vs-switch v-model="isAdminOrganization" color="success" />
    </div>
    <div class="form-user">
      <vs-input
        v-model="first_name"
        v-validate="'required|alpha'"
        :danger="this.errors.has('first_name')"
        :danger-text="this.errors.first('first_name')"
        name="first_name"
        size="large"
        type="text"
        label-placeholder="Nombre"
      />
      <vs-input
        v-model="last_name"
        v-validate="'required|alpha'"
        :danger="this.errors.has('last_name')"
        :danger-text="this.errors.first('last_name')"
        name="last_name"
        size="large"
        type="text"
        label-placeholder="Apellido"
      />
      <vs-input
        v-model="email"
        v-validate="'required|email'"
        :danger="this.errors.has('email')"
        :danger-text="this.errors.first('email')"
        name="email"
        size="large"
        type="email"
        label-placeholder="Email"
      />
      <vs-input
        v-model="phone"
        v-validate="'required|numeric|min:10|max:10'"
        :danger="this.errors.has('phone')"
        :danger-text="this.errors.first('phone')"
        name="phone"
        size="large"
        type="string"
        label-placeholder="Teléfono"
      />
      <vs-input
        v-model="dni"
        v-validate="'required|numeric|min:8|max:8'"
        :danger="this.errors.has('dni')"
        :danger-text="this.errors.first('dni')"
        name="dni"
        size="large"
        type="string"
        label-placeholder="DNI"
      />
      <vs-input
        v-model="cuil"
        v-validate="'required|min:13|max:13'"
        :danger="this.errors.has('cuil')"
        :danger-text="this.errors.first('cuil')"
        name="cuil"
        size="large"
        type="string"
        label-placeholder="CUIL"
      />
    </div>
    <br>
    <div class="user-roles">
      <div class="user-roles__title">
        Establecimientos
      </div>
      <div class="user-roles__list">
        <div class="list-header">
          <div>Nombre</div>
          <div class="headers">
            <div>Admin</div>
            <div>Operar</div>
            <div>Lectura</div>
          </div>
        </div>
        <div class="list-content">
          <div v-for="est in establishments" :key="est.id" class="user">
            <div class="establishment-name">
              {{ est.name }}
            </div>
            <UserRoles :est='est' :user-id="String(adminId)" @updated-rol="updateEstablishmentRoles"/>
          </div>
        </div>
      </div>
    </div>
    <div class="offer-buttons">
      <vs-button color="#e0e0e0" type="filled" @click="goBack">Volver</vs-button>
      <button
        data-test="button-createoffer"
        type="filled"
        class="btn btn--large success"
        :class="{ 'btn--loading': loading }"
        @click="validateAdmin()"
      >
        Crear usuario
      </button>
    </div>
  </div>
</template>

<script>
import { print } from "graphql";
import gql from "graphql-tag";
import axios from "axios";
import { Validator } from "vee-validate";

import UserRoles from "./organizationSettings/UserRoles.vue"

const userDetail = gql`
  query userDetail($currentUserToken: String!, $userId: Int!) {
    userDetail(currentUserToken: $currentUserToken, userId: $userId) {
      establishments {
        id
        name
      }
      organizationId
    }
  }
`

const createAdminUser = gql`
  mutation backendCreateUserBackoffice(
    $dni: String!,
    $cuil: String!,
    $phone: String!,
    $lastname: String!,
    $firstname: String!,
    $email: String!,
    $organizationId: String,
    $establishmentRoles: [EstablishmentRoleInput!],
    $currentUserToken: String!
    $isUserAdminOrganization: Boolean!
  ) {
    backendCreateUserBackoffice(
      dni: $dni,
      cuil: $cuil,
      phone: $phone,
      lastname: $lastname,
      firstname: $firstname,
      email: $email,
      organizationId:
      $organizationId,
      establishmentRoles:
      $establishmentRoles,
      currentUserToken: $currentUserToken
      isUserAdminOrganization: $isUserAdminOrganization
    ) {
      code
      success
      message
    }
  }
`;

export default {
  name: "create-admin-user-form",
  components: {
    UserRoles
  },
  props: {
    adminId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      dni: "",
      cuil: "",
      organizationId: "",
      establishments: undefined,
      establishmentsRoles: [],
      isAdminOrganization: true,

      loading: false,
    }
  },
  beforeMount() {
    this.getUser();
  },
  methods: {
    getUser() {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(userDetail),
        variables: {
          currentUserToken: localStorage.getItem('USER_TOKEN'),
          userId: this.adminId
        }
      }})
      .then((res) => {
        if (!res.data.errors) {
          const { userDetail } = res.data.data;
          this.organizationId = String(userDetail.organizationId);
          this.establishments = userDetail.establishments;

          this.establishments.forEach((e) => {
            this.establishmentsRoles.push({establishmentId: e.id, role: ""});
          })
        } else {
          console.log(res.data.errors);
        }
      })
      .catch((err) => {
        console.log(err);
      })
    },

    updateEstablishmentRoles (id, rol) {
      if (this.establishmentsRoles.find(e => e.establishmentId === id)) {
        if (rol) {
          this.establishmentsRoles.find(e => e.establishmentId === id).role = rol
        } else {
          this.establishmentsRoles.splice(e => e.establishmentId === id)
        }
      } else {
        this.establishmentsRoles.push({establishmentId: id, role: rol})
      }
    },

    validateAdmin() {
      this.$validator.validate().then((res) => {
        if (res) {
          this.createAdminUser();
        }
      });
    },

    createAdminUser() {
      this.loading = true;
      axios
        .post(`${process.env.VUE_APP_GRAPH_PATH}`, {
          query: print(createAdminUser),
          variables: {
            dni: this.dni,
            cuil: this.cuil,
            phone: this.phone,
            lastname: this.last_name,
            firstname: this.first_name,
            email: this.email,
            organizationId: this.organizationId,
            establishmentRoles: this.establishmentsRoles,
            currentUserToken:  localStorage.getItem('USER_TOKEN'),
            isUserAdminOrganization: this.isAdminOrganization,
          },
        })
        .then((res) => {
          if (res.data.data.backendCreateUserBackoffice.success) {
            this.$vs.notify({
              title: "Usuario creado",
              time: 8000,
              text: "El usuario fue creado con éxito",
              color: "#50b83d",
              position: "top-right",
              icon: "check_circle",
            });
            this.$router.push("/admin/organizations");
          } else {
            this.$vs.notify({
              title: "Ha ocurrido un error",
              time: 3000,
              text: "Por favor intente crear el usuario nuevamente",
              color: "#DE3618",
              position: "top-right",
              icon: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>

<style lang="scss" scoped>
.gap-7 {
  gap: 7px
}
.gap-24 {
  gap: 24px;
}
.form-user {
  display: block;

  @media (min-width: 992px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 7px;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
  }
}

.user-roles__list {
  overflow: auto;
  white-space: nowrap;
}

.list-header {
  .headers {
    grid-template-columns: repeat(3, 1fr);
    display: grid;
    grid-column-gap: 30px;
    grid-row-gap: 30px;

    div {
      min-width: 53px;
    }

    div:nth-child(1) {
      grid-area: 1 / 1 / 2 / 2 !important;
    }
    div:nth-child(2) {
      grid-area: 1 / 2 / 2 / 3 !important;
    }
    div:nth-child(3) {
      grid-area: 1 / 3 / 2 / 4 !important;
    }
  }
}

.user-roles .list-content .select-roles {
  grid-template-columns: repeat(3, minmax(53px, 1fr));
}

.offer-buttons {
  margin-top: 3em;
  display: flex;
  justify-content: space-between;

  @media (max-width: 992px) {
    flex-direction: column;

    button {
      order: 2;
    }

    .success {
      order: 1;
      margin-bottom: 1em;
      padding: 1em;
    }
  }
}
</style>